import { TTypeOfModalWindow, IReportsWithCustomProps } from './reportsContainerContext';

export enum ReportsContainerActionTypes {
	SET_REPORTS = 'SET_REPORTS',
	CHANGE_TYPE_OF_MODAL_WINDOW = 'CHANGE_TYPE_OF_MODAL_WINDOW',
}

interface ISetReports {
	type: ReportsContainerActionTypes.SET_REPORTS;
	payload: {
		reports: IReportsWithCustomProps[];
	};
}

interface IChangeTypeOfModalWindow {
	type: ReportsContainerActionTypes.CHANGE_TYPE_OF_MODAL_WINDOW;
	payload: {
		typeOfModalWindow: TTypeOfModalWindow;
	};
}

export type TReportsContainerAction = ISetReports | IChangeTypeOfModalWindow;
